import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import withUser from '../HOC/HOCwithUser.jsx';
import { connect } from 'react-redux';
import { compose } from 'redux';
import * as actions from '../../actions';
import {
    List,
    ListItem,
    ListItemAvatar,
    Button,
    ListItemSecondaryAction,
    ListItemText,
    Paper
} from '@material-ui/core';
import ProgressiveImage from 'react-progressive-image';
import ContentLoader from 'react-content-loader';
import { FormattedMessage, injectIntl } from 'react-intl';
import moment from 'moment';
const styles = theme => ({
    root: {
        width: '100%'
    },
    inline: {
        display: 'inline'
    },
    margin: {
        margin: theme.spacing.unit
    },
    extendedIcon: {
        marginRight: theme.spacing.unit
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        marginBottom: '10px'
    }
});
class PromocodeList extends React.Component {
    componentDidMount() {
        this.props.promoCodeListAction();
    }
    renderPromoImage = index => {
        return (
            <div style={{ width: 200, height: 210 }} key={index}>
                <ContentLoader
                    height={220}
                    width={200}
                    speed={2}
                    primaryColor="#f3f3f3"
                    secondaryColor="#ecebeb"
                >
                    <rect x="0" y="0" rx="2" ry="2" width="200" height="210" />
                </ContentLoader>
            </div>
        );
    };
    render() {
        const { promoData, classes } = this.props;
        if (promoData.length == 0) {
            return (
                <Paper>
                    <p style={{ color: '#000', padding: '10px' }}>
                        <FormattedMessage
                            id="noPromocodeFound"
                            defaultMessage="No Promocode found"
                        />
                    </p>
                </Paper>
            );
        }
        return (
            <List className={classes.root}>
                {promoData.length >= 0 &&
                    promoData.map((promo, index) => {
                        return (
                            <ListItem key={promo.key} className={classes.paper}>
                                <ListItemAvatar>
                                    <ProgressiveImage
                                        delay={2000}
                                        src={promo.image.medium}
                                        placeholder="promo-image"
                                    >
                                        {(src, loading) =>
                                            loading ? (
                                                this.renderPromoImage(index)
                                            ) : (
                                                <img
                                                    width="200px"
                                                    height="220px"
                                                    src={src}
                                                    alt="promo image"
                                                />
                                            )
                                        }
                                    </ProgressiveImage>
                                </ListItemAvatar>

                                <ListItemText
                                    primary={
                                        <h3 id="hello" value={promo.code}>
                                            {promo.code}
                                        </h3>
                                    }
                                    secondary={
                                        <React.Fragment>
                                            <h6>{promo.heading}</h6>
                                            {/* {promo.description} */}
                                            <br />

                                            <b>
                                                {' '}
                                                Valid on your{' '}
                                                {promo.booking_count} bookings
                                            </b>
                                        </React.Fragment>
                                    }
                                />
                                <ListItemSecondaryAction>
                                    <div className="col-md-12 col-sm-12 col-xs-12">
                                        <Button
                                            variant="contained"
                                            size="large"
                                            color="primary"
                                            className={classes.margin}
                                        >
                                            Expire On:{' '}
                                            {moment(promo.end_date).format(
                                                'DD-MMM-Y'
                                            )}
                                        </Button>
                                    </div>
                                </ListItemSecondaryAction>
                            </ListItem>
                        );
                    })}
            </List>
        );
    }
}

const mapStateToProps = ({ promos }) => {
    return {
        promoData: promos.promoData
    };
};
const composedComponent = compose(
    withStyles(styles),
    connect(mapStateToProps, actions)
);

export default composedComponent(PromocodeList);



// WEBPACK FOOTER //
// ./src/components/Customer/PromocodeList.jsx